import { Heading, HeadingProps, useColorModeValue } from "@chakra-ui/react";

export function Heading22({ children, ...rest }: HeadingProps) {
  const headerColor = useColorModeValue("cdsGrey.900", "var(--chakra-colors-whiteAlpha-900)");
  return (
    <Heading color={headerColor} fontSize="22px" lineHeight="26px" fontWeight="600" {...rest}>
      {children}
    </Heading>
  );
}

export function Heading20({ children, ...rest }: HeadingProps) {
  return (
    <Heading color="content.primary" fontSize="xl" lineHeight="24px" fontWeight="700" {...rest}>
      {children}
    </Heading>
  );
}

export function Heading18({ children, ...rest }: HeadingProps) {
  return (
    <Heading color="content.primary" fontSize="18px" lineHeight="21.6px" fontWeight="700" {...rest}>
      {children}
    </Heading>
  );
}

export function Heading16({ children, ...rest }: HeadingProps) {
  return (
    <Heading color="content.primary" fontSize="lg" lineHeight="19.2px" fontWeight="700" {...rest}>
      {children}
    </Heading>
  );
}

export function Heading14({ children, ...rest }: HeadingProps) {
  return (
    <Heading color="content.primary" fontSize="md" lineHeight="16.8px" fontWeight="700" {...rest}>
      {children}
    </Heading>
  );
}

export function Heading12({ children, ...rest }: HeadingProps) {
  return (
    <Heading color="content.primary" fontSize="sm" lineHeight="13px" fontWeight="700" {...rest}>
      {children}
    </Heading>
  );
}
